import React from 'react';

const SvgUndo: React.FC<React.SVGProps<SVGSVGElement>> = (
  props: React.SVGProps<SVGSVGElement>,
) => {
  return (
    <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...props}>
      <g strokeLinecap="round" strokeLinejoin="round">
        <path d="M8 5L5 8l3 3" />
        <path d="M5 8h9c3.314 0 6 2.462 6 5.5v0c0 3.038-2.686 5.5-6 5.5H6" />
      </g>
    </svg>
  );
};

export default SvgUndo;
